@if (image) {
  <ca-image-loader
    [background]="background"
    [image]="image"
    [blur]="blur"
  ></ca-image-loader>
}
<div
  class="initials"
  [class.small]="small"
  [class.chip]="chip"
  [style]="
    fontSize != null
      ? {
          fontSize: fontSize + 'px'
        }
      : {}
  "
>
{{ initials }}
</div>
